import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { ROUTES } from 'utils/constants';

export function ForgotPasswordLink(): JSX.Element {
  const [t, { language }] = useTranslation();

  return (
    <p>
      <Link
        to={`/${language}/${ROUTES.FORGOT_PASSWORD}`}
        data-test-id="forgot-password-link"
      >
        {t('forms.forgot_password_link')}
      </Link>
    </p>
  );
}
